import React, { useState } from 'react';
import './MusicGuide.css';
import { 
  MusicToggleIcon, 
  PlayIcon, 
  VolumeIcon, 
  HelpIcon 
} from '../MusicPlayer/Icons';

const MusicGuide = ({ onClose }) => {
  const [currentStep, setCurrentStep] = useState(0);

  const steps = [
    {
      title: "Chào mừng đến với Music Player!",
      content: "Đây là hướng dẫn sử dụng tính năng âm nhạc thư giãn trên trang web của chúng tôi.",
      icon: <MusicToggleIcon size={60} color="#667eea" />
    },
    {
      title: "Cách mở Music Player",
      content: "Nhấn vào nút âm nhạc ở góc dưới bên phải màn hình để mở/đóng Music Player.",
      icon: <MusicToggleIcon size={60} color="#06b6d4" />
    },
    {
      title: "Điều khiển phát nhạc",
      content: "Sử dụng các nút để phát, tạm dừng, chuyển bài trước và bài tiếp theo.",
      icon: <PlayIcon size={60} color="#10b981" />
    },
    {
      title: "Điều chỉnh âm lượng",
      content: "Kéo thanh trượt âm lượng để tăng/giảm âm lượng theo ý muốn.",
      icon: <VolumeIcon size={60} color="#f59e0b" />
    },
    {
      title: "Chọn bài hát",
      content: "Nhấn vào bài hát trong danh sách để chuyển đổi bài hát ngay lập tức.",
      icon: <HelpIcon size={60} color="#8b5cf6" />
    },
    {
      title: "Tận hưởng âm nhạc!",
      content: "Bây giờ bạn có thể thưởng thức âm nhạc thư giãn trong khi sử dụng trang web.",
      icon: <MusicToggleIcon size={60} color="#ec4899" />
    }
  ];

  const nextStep = () => {
    if (currentStep < steps.length - 1) {
      setCurrentStep(currentStep + 1);
    } else {
      onClose();
    }
  };

  const prevStep = () => {
    if (currentStep > 0) {
      setCurrentStep(currentStep - 1);
    }
  };

  const skipGuide = () => {
    onClose();
  };

  return (
    <div className="music-guide-overlay">
      <div className="music-guide-modal">
        <div className="music-guide-header">
          <h2>Hướng dẫn sử dụng Music Player</h2>
          <button className="close-btn" onClick={onClose}>✕</button>
        </div>
        
        <div className="music-guide-content">
          <div className="step-indicator">
            {steps.map((_, index) => (
              <div 
                key={index}
                className={`step-dot ${index === currentStep ? 'active' : ''} ${index < currentStep ? 'completed' : ''}`}
              />
            ))}
          </div>
          
          <div className="step-content">
            <div className="step-icon">{steps[currentStep].icon}</div>
            <h3 className="step-title">{steps[currentStep].title}</h3>
            <p className="step-description">{steps[currentStep].content}</p>
          </div>
        </div>
        
        <div className="music-guide-footer">
          <button 
            className="btn-secondary" 
            onClick={prevStep}
            disabled={currentStep === 0}
          >
            Trước
          </button>
          
          <div className="guide-actions">
            <button className="btn-text" onClick={skipGuide}>
              Bỏ qua
            </button>
            <button className="btn-primary" onClick={nextStep}>
              {currentStep === steps.length - 1 ? 'Hoàn thành' : 'Tiếp theo'}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default MusicGuide;
